import { apiPost } from "@/api/client";

const SESSION_KEY = "project_local_analytics_session";

export function getAnalyticsSessionId() {
  try {
    const existing = window.localStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const created = `sess_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    window.localStorage.setItem(SESSION_KEY, created);
    return created;
  } catch {
    return `sess_ephemeral_${Date.now().toString(36)}`;
  }
}

/** Fire-and-forget product analytics event. Never throws. */
export async function trackAnalyticsEvent(payload = {}) {
  try {
    await apiPost("/analytics/track", {
      session_id: getAnalyticsSessionId(),
      path: typeof window !== "undefined" ? window.location.pathname : "",
      ...payload,
    });
  } catch {
    // Analytics must never interrupt UX.
  }
}
